import { mapAssetReferences } from './assetReferenceMapper'
import { setAccountData, setPostMetaData } from './dataSetters'
import { mapLinksWithData } from './linksWithDataMapper'
import { mapPostComponentData } from './postComponentsMapper'
import { setPostOptionAndComponentData } from './postOptionMapper'

export class BackbonePostTranslator {
  constructor({
    postJson,
    linksWithDataJson,
    accountJson,
    postComponentsJson,
    coverAssetsJson,
    optionValueJson,
  }) {
    this.post = postJson
    this.linksWithData = linksWithDataJson
    this.account = accountJson
    this.optionValues = optionValueJson || []
    this.postComponents = postComponentsJson
    this.coverAssets = coverAssetsJson
    this.updateProps({
      postJson,
      linksWithDataJson,
      accountJson,
      postComponentsJson,
      coverAssetsJson,
      optionValueJson,
    })
  }

  // allow better testing for conditionally calling these methods
  updateMetaData = (post) => setPostMetaData(post)

  updateLinksWithData = (post) => mapLinksWithData(post)

  updateAccount = (post) => setAccountData(post)

  updateAssets = ({ assets, coverAssets }) =>
    mapAssetReferences({ assets, coverAssets })

  updatePostOptionsAndComponents = (
    post,
    newPostComponents,
    optionValues,
    coverAssets
  ) =>
    setPostOptionAndComponentData(
      post,
      newPostComponents,
      optionValues,
      coverAssets
    )

  updatePostComponents = (post) => mapPostComponentData(post)

  updateProps = ({
    postJson,
    linksWithDataJson,
    accountJson,
    postComponentsJson,
    coverAssetsJson,
    optionValueJson,
    updateArray = [],
  }) => {
    const post = postJson || this.post
    const linksWithData = linksWithDataJson || this.linksWithData
    const postComponents = postComponentsJson || this.postComponents
    const coverAssets = coverAssetsJson || this.coverAssets
    const account = accountJson || this.account
    const optionValues = optionValueJson || this.optionValues
    const updateAll = !updateArray.length || !this.props
    const prevProps = this.props || {}
    let nextProps = { ...prevProps }

    // attributes shared across all post types
    if (updateAll || updateArray.includes('metaData')) {
      const postMetaData = this.updateMetaData(post)
      nextProps = { ...nextProps, ...postMetaData }
    }

    // links with data attributes
    if (updateAll || updateArray.includes('linksWithData')) {
      const newLinksWithData = this.updateLinksWithData(linksWithData)
      nextProps = { ...nextProps, linksWithData: newLinksWithData }
    }

    // account attributes
    if (updateAll || updateArray.includes('account')) {
      const accountData = this.updateAccount(account)
      nextProps = { ...nextProps, ...accountData }
    }

    // assets that are not part of postOptions
    if (updateAll || updateArray.includes('assets')) {
      const assetData = this.updateAssets({
        assets: post.asset_reference_posts,
        coverAssets,
      })
      nextProps = { ...nextProps, assets: assetData }
    }

    // all post options and post components
    if (updateAll || updateArray.includes('postOptions')) {
      const newPostComponents = this.updatePostComponents(postComponents)
      const postOptionAndComponentData = this.updatePostOptionsAndComponents(
        post,
        newPostComponents,
        optionValues,
        coverAssets
      )
      nextProps = { ...nextProps, ...postOptionAndComponentData }
    }

    this.props = nextProps
    this.post = post
    this.coverAssets = coverAssets
    this.account = account
    this.linksWithData = linksWithData
    this.postComponents = postComponents
    return nextProps
  }
}
